import React, {useState, useContext, useEffect} from 'react'
import { Image, Divider, Select } from 'antd';
import {useFetch} from './../utils/hooks/useFetch'
import { appContext } from '../AppContext';

const { Option, OptGroup } = Select;

export default function PhotoOverview() {
    const [images, setImages] = useState([])
    const [albums, setAlbums] = useState([])
    const [currentAlbum, setCurrentAlbum] = useState({})
    const [appState] = useContext(appContext)

    const [doFetch] = useFetch();

    useEffect(() => {
        doFetch("/api/photo/albums")
            .then(response => {
                if(response.isSuccess) {
                    setAlbums(response.result)
                }
            })
    }, //eslint-disable-next-line
    [])

    function onClick(album) {
        setCurrentAlbum(album)
        getPhotos(album)
    }

    function getPhotos(album) {
        doFetch(`/api/Photo/${album}`)
            .then(response => {
                if(response.result) {

                    const newImages = response.result.map(img => {
                        return <Image 
                                preview={{src:`${appState.baseUrl}/api/Photo/${album}/${img}`}} 
                                src={`${appState.baseUrl}/api/Photo/${album}/${img}/small`}
                                key={img} 
                                width={200}/>
                        })
                        setImages(newImages);
                        return;
                }
            })
      }


      function getAlbumOptions() {
        const zivaniaAlbums = albums.filter(_ => _.includes("Zivania"))
        let zivania = zivaniaAlbums.map(_ => <Option value={_}>{_}</Option>)
        let ziviaOptions = <OptGroup label={"Zivania"}>{zivania}</OptGroup >

        const tomAlbums = albums.filter(_ => _.includes("TOM"))
        let tom = tomAlbums.map(_ => <Option value={_}>{_}</Option>)
        let tomOptions = <OptGroup label={"TOM"}>{tom}</OptGroup >

        const spiritAlbums = albums.filter(_ => _.includes("Spirit"))
        let spirit = spiritAlbums.map(_ => <Option value={_}>{_}</Option>)
        let spiritOptions = <OptGroup label={"Spirit World"}>{spirit}</OptGroup >

        const zomerAlbums = albums.filter(_ => _.includes("Zomerlarp"))
        let zomer = zomerAlbums.map(_ => <Option value={_}>{_}</Option>)
        let zomerOptions = <OptGroup label={"Zomerlarp"}>{zomer}</OptGroup >

        const stormAlbums = albums.filter(_ => _.includes("Stormvloed"))
        let storm = stormAlbums.map(_ => <Option value={_}>{_}</Option>)
        let stormOptions = <OptGroup label={"Stormvloed"}>{storm}</OptGroup >

        const agnoiaAlbums = albums.filter(_ => _.includes("Agnoia"))
        let agnoia = agnoiaAlbums.map(_ => <Option value={_}>{_}</Option>)
        let agnoiaOptions = <OptGroup label={"Agnoia"}>{agnoia}</OptGroup >

        return <Select style={{ width: 200 }} onChange={onClick}> 
            {stormOptions}
            {zomerOptions}
            {tomOptions}
            {ziviaOptions}
            {spiritOptions}
            {agnoiaOptions}
        </Select>;
      }

      

    return (

        <>
            {getAlbumOptions()}

            {images.length > 0 &&
                <>
                    <Divider />
                    <h1>{currentAlbum} ({images.length})</h1>

                    {images.length > 0 &&
                        <>
                            <Divider />
                            <Image.PreviewGroup>
                                {images}
                            </Image.PreviewGroup>
                        </>
                    }
                </>
            }
        </>

    )



}